
import styled from 'styled-components';
import db from "../firebase";


const Login = (props) => {



    // const sendPost = (e) => {
    //     /**to prevent refresh when click enter */
    //     e.preventDefault();
    
    //     db.collection("anime").add({
    //         backgroundImg:"https://drive.google.com/uc?export=view&id=1dA8zMoJagoBmgnyKqBrayFnTJgx6qECo",
    //         cardImg:"https://drive.google.com/uc?export=view&id=1NO6I-cGmk7VDKYm6HpnZe4WH3ePLtKaS",
    //         description:"Midoriya Izuku was just a regular middle school student in a world where people with superpowers known as Quirks are the norm. However, he dreams of one day becoming a Hero, despite being bullied by his classmates for not having a Quirk. After being the only one to try and save his childhood friend, Katsuki, from a Villain, All Might, the world's greatest Hero, bestows upon him his own quirk, One For All. The story follows Izuku's entrance into Yuuei High School, a school that cultivates the next generation of Heroes.",
    //         subTitle:" Genre: Action, Comedy, School, Shounen, Super Power ",
    //         title:"My hero Academia",
    //         titleImg:"https://drive.google.com/uc?export=view&id=1j5dd6eJDYObzxU4khx6A8cIVg9d4YIpc",
    //         type:"original",
    //         trailerUrl:"https://www.youtube.com/embed/EPVkcwyLQQ8",
    //         videoPlayUrl:"",
    //     });        
    //   };

    return(
       <Container>
        <Content>
            <CTA>
                <CTALogoOne src="./images/home_logo.png" alt="" />
                {/* <SignUp onClick={login}>GET ALL THAT HERE</SignUp> */}
                <Description>
                    Get Premier Access to Sasuke Chronicles for  an additional fee with a Stealthy subscription.
                    As of 05/17/2021, the proce of Stealthy+ and the Stealthy Bundle will be inreased by $1.
                </Description>
                {/* <CTALogoTwo src="./images/cta-logo-two.png" alt="" /> */}
            </CTA>
            <BgImage/>
        </Content>
       </Container>
    )
};

const Container =styled.section`
overflow: hidden;
display: flex;
flex-direction: column;
text-align:center;
height:100vh;

`
const Content = styled.div`
margin-bottom:10vw;
width:100%;
position: relative;
min-height: 100vh;
box-sizing: border-box;
display: flex;
justify-content: center;
align-items: column;
flex-direction: column;
padding: 80px 40px;
height: 100%
`;

const BgImage = styled.div`
height:100%;
background-image :url("./images/login-background.jpg") ;
background-position: top;
background-size:cover;
position: absolute;
top:0;
right:0;
left:0;
z-index:-1;
`;

const CTA = styled.div`
    max-width: 650px;
    width:100%;
    display:flex;
    flex-direction:column;
`;

const CTALogoOne = styled.img`
    margin-bottom: 12px;
    max-width: 600px;
    min-height: 1px;
    display: block;
    width: 100%;
`;

const SignUp =styled.a`
    font-weight:bold;
    color: #f9f9f9;
    background-color: #0063e5;
    margin-bottom:12px;
    width:100%;
    letter-spacing :1.5px;
    font-size: 18px;
    padding: 16.5px 0;
    border: 1px solid transparent;
    border-radius:4px;

    &:hover {
        background-color:#0483ee;
    }
`;

const Description= styled.p`
color: hsla(0,0%,95.3%, 1);
font-size:11px;
margin:0 0 24px;
line-height: 1.5;
letter-spacing: 1.5px;
`;

const CTALogoTwo = styled.img`
max-width:600px;
margin-bottom:20px;
display: inline-block;
vertical-align: bottom;
width:100%;
`;

export default Login;